// Laptop image
import acer from './Images/Laptops/acer.jpg';
import asus from './Images/Laptops/asus.jpg';
import dell from './Images/Laptops/dell.jpg';
import hp from './Images/Laptops/hp.jpg';
import macbook from './Images/Laptops/macbook.jpg';
import msi from './Images/Laptops/msi.jpg';
// Phone image
import inphone11 from './Images/Phones/iphone11.jpg';
import iphonex from './Images/Phones/iphonex.jpg';
import nokia from './Images/Phones/nokia.jpg';
import oppo from './Images/Phones/oppo.jpg';
import vivo from './Images/Phones/vivo.jpg';
// keyboard image
import gamming from './Images/Keyboards/gamming_keyboard.jpg';
import laserVirtual from './Images/Keyboards/laser_virtual.jpg';
import mechanical from './Images/Keyboards/mechanical_keyboard.jpg';
import wireless from './Images/Keyboards/wireless_keyboard.jpg';
import mechanical2 from './Images/Keyboards/mechanical2_keyboard.jpg';
const data = [
    // laptop
    {
        id: 1,
        title: "Acer",
        price: 299,
        count: 1,
        type: "laptop",
        image: acer
    },
    {
        id: 2,
        title: "Asus",
        price: 1299,
        count: 1,
        type: "laptop",
        image: asus
    },
    {
        id: 3,
        title: "Dell",
        price: 258,
        count: 1,
        type: "laptop",
        image: dell
    },
    {
        id: 4,
        title: "hp",
        price: 749,
        count: 1,
        type: "laptop",
        image: hp
    },
    {
        id: 5,
        title: "MacBook",
        price: 1199,
        count: 1,
        type: "laptop",
        image: macbook
    },
    {
        id: 6,
        title: "MSI",
        price: 1455,
        count: 1,
        type: "laptop",
        image: msi
    },

    // phone
    {
        id: 7,
        title: "Iphone 11",
        price: 1399,
        count: 1,
        type: "phone",
        image: inphone11
    },
    {
        id: 8,
        title: "Iphone X",
        price: 1279,
        count: 1,
        type: "phone",
        image: iphonex
    },
    {
        id: 9,
        title: "Nokia",
        price: 50,
        count: 1,
        type: "phone",
        image: nokia
    },
    {
        id: 10,
        title: "Oppo",
        price: 339,
        count: 1,
        type: "phone",
        image: oppo
    },
    {
        id: 11,
        title: "Vivo",
        price: 235,
        count: 1,
        type: "phone",
        image: vivo
    },
    //keyboard
    {
        id: 12,
        title: "Gamming",
        price: 98,
        count: 1,
        type: "keyboard",
        image: gamming
    },
    {
        id: 13,
        title: "Laser Virtual",
        price: 134,
        count: 1,
        type: "keyboard",
        image: laserVirtual
    },
    {
        id: 14,
        title: "Mechanical",
        price: 167,
        count: 1,
        type: "keyboard",
        image: mechanical
    },
    {
        id: 15,
        title: "Wireless",
        price: 129,
        count: 1,
        type: "keyboard",
        image: wireless
    },
    {
        id: 16,
        title: "Mechanical 2",
        price: 159,
        count: 1,
        type: "keyboard",
        image: mechanical2
    },

]
export default data;